import { evidenceCards } from "@/mocks/homeData";
import { Heat, SectionHead, Shell } from "./ui";

export default function EvidenceSection() {
  return (
    <section className="bg-background-100/60">
      <Shell>
        <div className="py-10 md:py-14">
          <SectionHead
            id="proof"
            kicker="Evidence · 证据链档案"
            title="实锤有据"
            subtitle="每一项「实锤」都附来源、形式与置信度。可信度分级标注，帮你在信息爆炸里快速判断哪些站得住脚。"
            linkText="查看证据存证库"
          />

          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            {evidenceCards.map((c) => (
              <article
                key={c.id}
                className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:-translate-y-1 hover:border-primary-200"
              >
                <div className="relative h-44 w-full overflow-hidden">
                  <img src={c.src} alt={c.title} className="h-full w-full object-cover transition duration-500 group-hover:scale-105" />
                  <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-md bg-foreground-950/85 px-2 py-1 text-xs font-bold text-background-50 backdrop-blur">
                    <i className="ri-focus-3-line text-accent-400" />
                    置信度 {c.level}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="mb-2 flex items-center gap-2 text-[11px] text-foreground-500">
                    <span className="inline-flex items-center gap-1 rounded bg-secondary-100 px-2 py-0.5 font-semibold text-secondary-900">
                      <i className="ri-file-lock-line" />{c.kind}
                    </span>
                    <span className="inline-flex items-center gap-1"><i className="ri-time-line" />{c.time}</span>
                  </div>
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-800">
                    <a href="#top">{c.title}</a>
                  </h3>
                  <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">{c.summary}</p>
                  <div className="mt-auto flex items-center justify-between pt-4">
                    <span className="inline-flex items-center gap-1 text-xs font-semibold text-accent-700"><i className="ri-archive-line" />编号 HP-2026-0{c.id}</span>
                    <Heat value="证据已存证" />
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </Shell>
    </section>
  );
}